/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A dashboard a widget is placed on.
 */
export type WidgetDashboard = {
  id: string;
  name: string;
};

/** @internal */
export const WidgetDashboard$inboundSchema: z.ZodMiniType<
  WidgetDashboard,
  unknown
> = z.object({
  id: z.string(),
  name: z.string(),
});

export function widgetDashboardFromJSON(
  jsonString: string,
): SafeParseResult<WidgetDashboard, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WidgetDashboard$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WidgetDashboard' from JSON`,
  );
}
